
export default {
    errors: {
            "max_user": "Die maximale Anzahl an Benutzern in dieser Gruppe wurde erreicht.",
            "user_in_project": "Der Benutzer mit dieser E-Mail Adresse ist bereits in der Gruppe."
    },
    getErrorMsg(key) {
        return this.errors[key];
    }
}